import React from 'react';
import { gql } from '@apollo/client';
import { useGetCategoriesUsageLazyQuery } from '../../../../models/graphql';
import { CategoryUsageController } from './CategoryUsage.controller';

gql`
  query GetCategoriesUsage($workspaceId: ID!, $startDate: String!, $endDate: String!, $selectedProfilesIds: [ID!]!) {
    workspace(workspaceId: $workspaceId) {
      categories {
        ...CategoryFields
      }
    }
    analyticsPostStats(
      socialProfileIds: $selectedProfilesIds
      rangeStartDate: $startDate
      rangeEndDate: $endDate
      groupByType: CATEGORY
      groupByDate: false
    ) {
      postStatsByCategory {
        categoryId
        postStats {
          postCount
          rangeStartDate
          rangeEndDate
          likes
          comments
          shares
        }
      }
    }
  }
`;

export const CategoryUsageApollo = () => {
  const [getData, { data, loading }] = useGetCategoriesUsageLazyQuery();
  return <CategoryUsageController getData={getData} data={data} loading={loading} />;
};
